module.exports = __webpack_public_path__ + "img/project-25.ecb435b1.png";